export default __webpack_public_path__ + "static/media/Reddit4.177289f2.PNG";